import React from 'react';

const FOUNDER_PHOTO = 'https://res.cloudinary.com/dp6nne059/image/upload/v1773336964/aureate-residences/team/team_kingkof_kofi_opoku-ohemeng_1f55c13e.jpg';

const FounderSection = () => (
  <section className="founder" id="founder" data-testid="founder-section">
    <div className="wrap f-grid">
      <div className="f-photo">
        <img src={FOUNDER_PHOTO} alt="Kingkof Kofi Opoku-Ohemeng, Founder and CEO of Aureate Residences" />
      </div>
      <div className="f-body">
        <span className="eyebrow">Why Aureate</span>
        <p className="big">Accommodation is an asset, and it deserves to be run like one.</p>
        <p>Aureate Residences brings the practice of major infrastructure and asset programmes to accommodation: a clear requirement, the right property, proper preparation and disciplined day-to-day operation.</p>
        <p className="name">
          Kingkof Kofi Opoku-Ohemeng
          <span>Founder and CEO &middot; over two decades delivering infrastructure and asset programmes across transport, aviation, ports, energy, utilities and buildings</span>
        </p>
        <div className="creds" aria-label="Professional credentials">
          <span>EUR ING</span>
          <span>FIAM</span>
          <span>CEng</span>
          <span>MCIOB</span>
          <span>CIWFM</span>
          <span>ISO 55001</span>
        </div>
      </div>
    </div>
  </section>
);

export default FounderSection;
